import { Component } from '@angular/core';

@Component({
  selector: 'app-wallet-seed-black',
  templateUrl: './wallet-seed-black.component.html',
  styleUrls: ['./wallet-seed-black.component.scss']
})
export class WalletSeedBlackComponent {

}
